export const ensureNumber = (value: string | number | undefined | null): number => {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

export const calculateTotals = (values: {
  single: number;
  double: number;
  triple: number;
  quadruple: number;
  quintuple: number;
  sextuple: number;
  extraBeds: number;
}) => {
  const {
    single,
    double,
    triple,
    quadruple,
    quintuple,
    sextuple,
    extraBeds
  } = values;

  const totalUnits = single + double + triple + quadruple + quintuple + sextuple;
  const totalPlaces = 
    (single * 1) + 
    (double * 2) + 
    (triple * 3) + 
    (quadruple * 4) + 
    (quintuple * 5) + 
    (sextuple * 6) +
    extraBeds;

  return {
    totalUnits,
    totalPlaces
  };
}; 